import React from 'react';
import { StyledSectionHeader } from './styles';

const SectionHeader = ({ tagline, title, subtitle }) => (
  <StyledSectionHeader>
    {tagline && <sup dangerouslySetInnerHTML={{ __html: tagline }} />}
    <h2 dangerouslySetInnerHTML={{ __html: title }} />
    {subtitle && <p dangerouslySetInnerHTML={{ __html: subtitle }} />}
  </StyledSectionHeader>
);

export default SectionHeader;
